import WebService from "Services/WebServices";
import { CONTACT_URL, SUBSCRIPTION_URL } from "Constants/options"


export const postWebService = async (name, email, subject, comment) => {
  try {
    let options = {
      method: 'POST',
      path: CONTACT_URL,
      data: {
        name,
        email,
        subject,
        comment,
      }
    };

    await WebService.getSharedInstance().callWebservice(
      options,
    );

    return true

  } catch (err) {
      return err
  }
};

export const postWebServiceWithEmail = async (email) => {
  try {
    let options = {
      method: 'POST',
      path: SUBSCRIPTION_URL,
      data: {
        email,
      }
    };

    await WebService.getSharedInstance().callWebservice(
      options,
    );

    return true

  } catch (err) {
      return err
  }
};
